module.exports = function (fox) {
	'use strict';

    require('./stylus/_requestPermissionPopup.styl');
	require('fox-dynamic-injection!fox-template-loader!./templates.tpl')(fox);

	//require('./stylus/_splash.styl');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/push-notifications/index.js
// module id = 582
// module chunks = 4